import { apiClient } from '../../../../lib/api/client';
import type {
  CustomerSegmentDetail,
  CustomerSegmentFormValues,
  CustomerSegmentListItem,
  GetCustomerSegmentsParams,
  PagedResult,
} from '../types';

export async function getCustomerSegments(
  params: GetCustomerSegmentsParams = {},
): Promise<PagedResult<CustomerSegmentListItem>> {
  const {
    pageNumber = 1,
    pageSize = 10,
    search,
    activeOnly,
  } = params;

  const searchParams = new URLSearchParams();
  searchParams.set('pageNumber', String(pageNumber));
  searchParams.set('pageSize', String(pageSize));

  if (search !== undefined && search !== '') searchParams.set('search', search);
  if (activeOnly !== undefined) searchParams.set('activeOnly', String(activeOnly));

  const response = await apiClient.get<PagedResult<CustomerSegmentListItem>>(
    `/settings/customer-segments?${searchParams.toString()}`,
  );
  return response.data;
}

export async function getCustomerSegmentById(id: string): Promise<CustomerSegmentDetail> {
  const response = await apiClient.get<CustomerSegmentDetail>(`/settings/customer-segments/${id}`);
  return response.data;
}

export async function createCustomerSegment(data: CustomerSegmentFormValues): Promise<{ id: string }> {
  const response = await apiClient.post<{ id: string }>('/settings/customer-segments', {
    title: data.title,
    description: data.description ?? null,
    isActive: data.isActive,
  });
  return response.data;
}

export async function deleteCustomerSegment(id: string): Promise<void> {
  await apiClient.delete(`/settings/customer-segments/${id}`);
}

export async function updateCustomerSegment(id: string, data: CustomerSegmentFormValues): Promise<void> {
  await apiClient.put(`/settings/customer-segments/${id}`, {
    title: data.title,
    description: data.description ?? null,
    isActive: data.isActive,
  });
}
